import React, { useState } from "react";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  Box,
  Card,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilterCategoryId,
  setFilterSearchString,
  setSort,
} from "../../../state/workshopSlice";
import style from "./ListFilters.module.css";

const ListFilters = () => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const [category, setCategory] = useState("");
  const [sortBy, setSortBy] = useState("registrationEndDate");
  const { showVirtual } = useSelector((state) => state.workshops.filter);
  const [sortDirection, setSortDirection] = useState("asc");

  const userWorkshops = useSelector((state) => state.workshops.userWorkshops);
  const categories = useSelector((state) => state.workshops.categories);

  const searchStringChanged = (event) => {
    setSearchValue(event.target.value);
    dispatch(setFilterSearchString(event.target.value));
  };

  const categoryChanged = (event) => {
    setCategory(event.target.value);
    dispatch(setFilterCategoryId(event.target.value));
  };

  const sortByChanged = (event) => {
    const newSortBy = event.target.value;
    setSortBy(newSortBy);
    dispatch(setSort({ sortBy: newSortBy }));
  };

  const showVirtualChanged = () => {
    dispatch(setSort({ showVirtual: !showVirtual }));
  };

  const sortDirectionChanged = () => {
    const newSortDirection = sortDirection === "desc" ? "asc" : "desc";
    setSortDirection(newSortDirection);
    dispatch(setSort({ sortDirection: newSortDirection }));
  };

  const sortByOptions = [
    { name: "Title", value: "title" },
    { name: "Start Date", value: "startDatetime" },
    { name: "Registration End Date", value: "registrationEndDate" },
  ];

  return (
    <Card
      sx={{
        bgcolor: "background.main",
        overflow: "visible",
      }}
      variant="outlined"
      className={style.filter}
    >
      <Typography variant="h6">Find a workshop</Typography>

      <FormControl
        sx={{ width: "100%", maxWidth: "100%", marginBottom: "0.75rem" }}
      >
        <TextField
          name="search"
          labelid="search-label"
          label="Search by title"
          value={searchValue}
          onChange={searchStringChanged}
          size="small"
          sx={{ backgroundColor: "white" }}
        />
      </FormControl>
      <Box className={style.advancedFilters}>
        <FormControl size="small" className={style.category}>
          <InputLabel id="category-filter-label">Filter by category</InputLabel>
          <Select
            labelid="category-filter-label"
            id="category-filter"
            value={category}
            label="Filter by category"
            onChange={categoryChanged}
            sx={{ backgroundColor: "white" }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {categories.map((cat) => (
              <MenuItem key={cat.categoryId} value={cat.categoryId}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box className={style.sort}>
          <FormControlLabel
            control={<Switch />}
            label="Online"
            sx={{ flexGrow: "1" }}
            checked={showVirtual}
            onChange={showVirtualChanged}
          />
          <Box>
            <FormControl size="small" sx={{ maxWidth: "100%", flexGrow: "1" }}>
              <InputLabel id="sortby-label">Sort by</InputLabel>
              <Select
                labelid="sortby-label"
                id="sortby"
                value={sortBy}
                label="Sort by"
                onChange={sortByChanged}
                sx={{ backgroundColor: "white" }}
              >
                {sortByOptions.map((sort) => (
                  <MenuItem key={sort.value} value={sort.value}>
                    {sort.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Tooltip title="Reverse sort order" placement="right" arrow>
              <IconButton
                onClick={sortDirectionChanged}
                sx={{ marginLeft: "0.25rem" }}
              >
                <SwapVertIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default ListFilters;
